import React, { useMemo, useRef } from 'react';
// import { Serializer as Mo } from '@ali/4ever-mo';
import { traverseEverJSON } from 'src/utils';
import './index.scss';
import { logError } from 'src/utils/tracker';
import { useDingRichEditor, useImgPreviewByRef } from 'src/hooks';
// const plugins = createZhiPlugins();
let mo;
const transformJson = (val, fileList = []) => {
    const keyMap = fileList?.reduce((map, cur) => {
        map[cur.fileKey] = cur.url;
        return map;
    }, {});
    // 递归替换富文本里面的图片
    traverseEverJSON(val, (tagName, value) => {
        if (tagName == 'img') {
            if (value?.id && keyMap[value.id]) {
                // console.log('value', value);
                value.src = keyMap[value.id];
            }
        }
    });
};
export default function RichEditor(props) {
    const { content, fileList, needRichEditor = false, ...restProps } = props;
    const htmlRef = useRef(null);
    const loaded = useDingRichEditor();
    const value = useMemo(() => {
        if (!loaded)
            return '';
        if (!mo) {
            // @ts-ignore
            mo = window.CangjieMo?.Serializer?.();
        }
        // let val: JsonML | Value |string = data?.releaseNotesContent;
        let val = content;
        if (!val)
            return '';
        const transformFun = needRichEditor ? mo.jsonMLToValue : mo.jsonMLToHTML;
        if (typeof val === 'string') {
            try {
                val = JSON.parse(val);
                transformJson(val, fileList);
                // console.log(val, 221);
                // 默认json片段 转为html 片段
                val = transformFun(val);
                // 默认json片段 转为value
                // val = mo.jsonMLToValue(val)
            }
            catch (error) {
                // console.error(error, error.message);
                try {
                    // 第一次解析会改错 忽略掉并重新尝试
                    if (error.message?.indexOf('getCurrentStack') > -1) {
                        val = transformFun(val);
                        // val = mo.jsonMLToValue(val as JsonML)
                    }
                    else {
                        // 兼容html片段
                        // val = mo.htmlToValue(val as string);
                    }
                }
                catch (error) {
                    logError(error, {
                        c2: 'parse release note detail fail'
                    });
                    console.error(error);
                }
            }
        }
        return val;
    }, [content, loaded]);
    // 图片预览
    useImgPreviewByRef(htmlRef, value);
    if (needRichEditor) {
        if (loaded && window.CangjieZhi) {
            const { Reader, createZhiPlugins } = window.CangjieZhi;
            const plugins = createZhiPlugins({ mention: {} });
            return React.createElement(Reader, { plugins: plugins, content: value, ...restProps });
        }
        return null;
    }
    // console.log('val', value);
    return (React.createElement("div", { ref: htmlRef, className: props.className, dangerouslySetInnerHTML: { __html: value } }));
}
